import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { flattenViewObject, jsonToCsv } from '../../util/AppData/viewObject';
const debug = process.env.REACT_APP_DEBUG && false;
export const DownloadButton = (props) => {
    const { viewObject, viewDefinition, adjacentFilter, includeHeaders = true, headersAsDisplayValues = true } = props;
    const flatViewObject = flattenViewObject(viewObject, viewDefinition, adjacentFilter, includeHeaders, headersAsDisplayValues);
    const csvResult = jsonToCsv(flatViewObject);
    debug && console.log('Download button got', { viewObject, viewDefinition, flatViewObject });
    const downloadButton = csvResult.data ? (_jsx(Button, { variant: 'outlined',
        href: `data:text/json;charset=utf-8,${encodeURIComponent(csvResult.data)}`,
        download: `${adjacentFilter.objectType}`, children: props.label ?? 'Download (.csv)' })) : null;
    return downloadButton;
};
